import {Injectable} from "@angular/core";
//import { Observable } from 'rxjs/Observable';
//import * as io from 'socket.io-client';
import { environment } from "../../../environments/environment";
import { HttpClientService } from '../../common/http-client.service';
import { Http, Headers, RequestOptions, ResponseContentType } from "@angular/http";


@Injectable()
export class HeaderService {
  // environment.SOCKET_URL
  // "http://localhost:3000/paypro"
  constructor(private http: HttpClientService) {
  }
  private url = environment.SOCKET_URL;
  private socket;
  public downloadBase = environment.COMMON_UTILS;
  public production = environment.production;
  sendMessage(message, userId) {

   // this.socket.emit(userId, { _id: message, userId: userId });
  }

  getMessages(userId, callback) {
  //  this.socket = io(this.url, { query: "user=" + userId });
   // this.socket.on(userId, (data) => {
    //  console.log(data);
     // callback(data);
   // });
  }

  downloadNotification1() {
    return this.http.get("download/242-richa_1524583548701/invalid/entries", null, 21).map(res=>{return res});
  }


  downloadNotification(url, userId){
    debugger;
    let headObj: any = {
      // 'userId': this.common.getUserId(),
      'Authorization': localStorage.getItem('tkn')
  };
  let headers = new Headers(headObj);
  let reqHead = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers
  });
  return this.http.get(url, null, 21, reqHead, 'blob').subscribe((data) => {
      this.downloadcsv(data, userId);
  });
  }

  downloadcsv(data, userId) {
    let a = document.createElement('a');
    a.setAttribute("id", "downloadCsv");
    let date = new Date();
    let Tdate = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
    a.download = userId + '_notification'+'.csv';
    a.href = window.URL.createObjectURL(data);
    a.textContent = 'Download CSV';
    a.dataset.downloadurl = ["text/csv;charset=ISO-8859-1", a.download, a.href].join(':');
    document.body.appendChild(a);
    setTimeout(function () {
        document.getElementById('downloadCsv').click();
        document.getElementById('downloadCsv').remove();
    }, 1000);
}
}




// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/header/header.service.ts